import React, {Component} from 'react';
import AOS from 'aos'
import './App.css';
import {Switch, Route} from 'react-router-dom'
import Navbar from './components/Navbar/Navbar';
import HarmburgerMenu from './components/HamburgerMenu/HamburgerMenu'
import Footer from './containers/Footer/Footer';
import Home from './containers/Home/Home';
import About from './containers/About/About';
import Contact from './containers/Contact/Contact';
import Project from './containers/Projects/Projects';
import Membership from './containers/Membership/Membership';
import Donation from './containers/Donation/Donation';

class App  extends Component{
  state = {
    showHarmburger: false, 
    showModal:false
  }
  harmburgerHandler = () => {
    this.setState((state) => {
      return {showHarmburger : !state.showHarmburger}
    })
  }
  componentDidMount(){
    AOS.init()
  }
  modalHandler = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showModal: !prevState.showModal
      }
    })
  }

  render(){
    return(
      <div className="App">
        <Membership
        show={this.state.showModal}
        handleModal={this.modalHandler}
        />
        <HarmburgerMenu 
        show={this.state.showHarmburger}
        clicked={this.harmburgerHandler}
        />
        <Navbar 
        clickedHarmburger={this.harmburgerHandler}
        joinNow={this.modalHandler}
         />
        <Switch>
          <Route path="/projects"  component={Project} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route path="/donate" component={Donation} />
          <Route path="/" exact render={(props) => <Home {...props} handleModal={this.modalHandler}/>} />
        </Switch>
        <Footer />
      </div>
    )
  }
}

export default App;
